import {
  NewRelicPlusPlugin,
  NewRelicPlusPublisher,
  NewRelicPublisher,
} from '@cof/stratum';
import { NewRelicCustomAttribute } from '@cof/refi-web-sdk/dist/utils/stratum.js';

/** CUSTOM STRATUM NEW RELIC PLUGIN */

export const NEW_RELIC_PLUGIN_NAME = 'refiPluginNewRelic';

export const applyPluginVarsAsAttributes = (interaction, vars) => {
  for (const [k, v] of Object.entries(vars)) {
    interaction.setAttribute(k, v);
  }
};

export class FtNewRelicPublisher extends NewRelicPublisher {
  // Override
  getDefaultInteraction(event) {
    const interaction = super.getDefaultInteraction(event);
    applyPluginVarsAsAttributes(
      interaction,
      event.plugins[NEW_RELIC_PLUGIN_NAME].vars
    );
    return interaction;
  }
}

export class FtNewRelicPlusPublisher extends NewRelicPlusPublisher {
  // Override
  getDefaultInteraction(event) {
    const interaction = super.getDefaultInteraction(event);
    applyPluginVarsAsAttributes(
      interaction,
      event.plugins[NEW_RELIC_PLUGIN_NAME].vars
    );
    return interaction;
  }
}

export const RefiNewRelicPlugin = () => {
  const plugin = NewRelicPlusPlugin();

  const vars = Object.values(NewRelicCustomAttribute).reduce((obj, key) => {
    obj[key] = null;
    return obj;
  }, {});

  return {
    name: NEW_RELIC_PLUGIN_NAME,
    eventTypes: plugin.eventTypes,
    publishers: [new FtNewRelicPublisher(), new FtNewRelicPlusPublisher()],
    vars,
  };
};
